import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const templateEndpoints = (build: McoEndpointBuilder) => ({
	templateGetEmailKeys: build.query({
		queryFn: (_: void) => apiClient.template.getEmailTemplateKeys(),
		providesTags: [ApiTag.Tenant, ApiTag.Template]
	}),
	templateGetEmailPreview: build.query({
		queryFn: apiClient.template.getEmailPreview,
		providesTags: [ApiTag.Tenant, ApiTag.Template]
	}),
	templateGetSmsKeys: build.query({
		queryFn: (_: void) => apiClient.template.getSmsTemplateKeys(),
		providesTags: [ApiTag.Tenant, ApiTag.Template]
	}),
	templateGetSmsPreview: build.query({
		queryFn: apiClient.template.getSmsPreview,
		providesTags: [ApiTag.Tenant, ApiTag.Template]
	}),
	templateSendSms: build.mutation({
		queryFn: apiClient.template.sendSms
	})
})

export default templateEndpoints
